var exports = {
  "KF": "UserVoiceTab.module__sliderLabel___VlliVl",
  "Gl": "UserVoiceTab.module__sliderLabelRow___VlliVl",
  "Qg": "UserVoiceTab.module__audioProcessing___VlliVl",
  "Om": "UserVoiceTab.module__audioProcessingCard___VlliVl",
  "ZT": "UserVoiceTab.module__deviceNotice___VlliVl",
  "ei": "UserVoiceTab.module__deviceNoticeText___VlliVl",
  "dv": "UserVoiceTab.module__deviceNoticeTitle___VlliVl",
  "H6": "UserVoiceTab.module__deviceNoticeDescription___VlliVl",
  "Ov": "UserVoiceTab.module__pttSettings___VlliVl",
  "jS": "UserVoiceTab.module__pttSettingRow___VlliVl",
  "ps": "UserVoiceTab.module__pttSettingDescription___VlliVl",
  "Np": "UserVoiceTab.module__profileSubSection___VlliVl",
  "aG": "UserVoiceTab.module__sensitivitySliderWrapper___VlliVl",
};

module.exports = exports;
